<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="accountProfile"
  >
    <form
      autocomplete="off"
      @submit.prevent="updateUser"
    >
      <p class="margin-bottom-large">
        <AtomAvatarEdition
          avatar-class="xlarge"
          :avatar-img="usuario.avatar"
          :user-info="{email: usuario.email, fecha_alta: usuario.fecha_alta}"
          wrapper-class="margin-right-large"
          @changeAvatarImage="changeAvatarImage"
        />
      </p>
      <br>

      <div class="m-container-primary">
        <div class="row">
          <div class="column column-3">
            <AtomSelectPrimaryTimeout
              v-model.number="usuario.pais"
              :elements="paises"
              :input-error="$v.usuario.pais.$error"
              key-field="id_pais"
              :label="$t('mEditionAccountProfile.inputs.pais.label')"
              :message-error="messageErrorPais"
              name="pais"
              reference="pais"
              text-field="nombre"
              @blur="$v.usuario.pais.$touch()"
              @input="readParametroDocumentoTipos($event); readParametroProvincias($event)"
            />
          </div>

          <div class="column column-3">
            <AtomSelectPrimary
              v-model.number="usuario.provincia"
              :elements="provincias"
              :input-error="$v.usuario.provincia.$error"
              key-field="id_provincia"
              :label="$t('mEditionAccountProfile.inputs.provincia.label')"
              :message-error="messageErrorProvincia"
              name="provincia"
              reference="provincia"
              text-field="nombre"
              @blur="$v.usuario.provincia.$touch()"
            />
          </div>

          <div class="column column-4">
            <AtomInputPrimary
              v-model="usuario.localidad"
              :label="$t('mEditionAccountProfile.inputs.localidad.label')"
              name="localidad"
              type="text"
            />
          </div>
        </div>

        <div class="row">
          <div class="column column-2">
            <AtomInputPrimary
              v-model="usuario.cod_postal"
              :label="$t('mEditionAccountProfile.inputs.cod_postal.label')"
              name="cod_postal"
              type="text"
            />
          </div>

          <div class="column column-4">
            <AtomInputPrimary
              v-model="usuario.linea1"
              :label="$t('mEditionAccountProfile.inputs.linea1.label')"
              name="linea1"
              type="text"
            />
          </div>

          <div class="column column-4">
            <AtomInputPrimary
              v-model="usuario.linea2"
              :label="$t('mEditionAccountProfile.inputs.linea2.label')"
              name="linea2"
              type="text"
            />
          </div>
        </div>

        <div class="row">
          <div class="column column-3">
            <AtomSelectPrimary
              v-model.number="usuario.fisica"
              :elements="$filters.parameters.persons"
              :input-error="$v.usuario.fisica.$error"
              key-field="id"
              :label="$t('mEditionAccountProfile.inputs.fisica.label')"
              :message-error="messageErrorFisica"
              name="fisica"
              reference="fisica"
              text-field="name"
              @blur="$v.usuario.fisica.$touch()"
            />
          </div>

          <div class="column column-7">
            <AtomInputPrimary
              v-model="usuario.razon_social"
              :input-error="$v.usuario.razon_social.$error"
              :label="usuario.fisica === 0
                ? $t('mEditionAccountProfile.inputs.razon_social.labelBusiness')
                : $t('mEditionAccountProfile.inputs.razon_social.labelName')"
              :message="$t('mEditionAccountProfile.inputs.razon_social.message')"
              :message-error="messageErrorRazonSocial"
              name="razon_social"
              reference="razon_social"
              type="text"
              @blur="$v.usuario.razon_social.$touch()"
            />
          </div>
        </div>

        <div class="row">
          <div class="column column-3">
            <AtomSelectPrimary
              v-model.number="usuario.documento_tipo"
              :elements="documentoTipos"
              :input-error="$v.usuario.documento_tipo.$error"
              key-field="id_documento_tipo"
              :label="$t('mEditionAccountProfile.inputs.documento_tipo.label')"
              :message-error="messageErrorTipoDoc"
              name="documento_tipo"
              reference="documento_tipo"
              text-field="nombre"
              @blur="$v.usuario.documento_tipo.$touch()"
            />
          </div>

          <div class="column column-7">
            <AtomInputPrimary
              v-model="usuario.documento_numero"
              :input-error="$v.usuario.documento_numero.$error"
              :label="$t('mEditionAccountProfile.inputs.documento_numero.label')"
              :message="$t('mEditionAccountProfile.inputs.documento_numero.message')"
              :message-error="messageErrorDocumentoNum"
              name="documento_numero"
              reference="documento_numero"
              type="text"
              @blur="$v.usuario.documento_numero.$touch()"
            />
          </div>
        </div>

        <div class="row">
          <div class="column column-5">
            <AtomInputPrimary
              v-model="usuario.telefono"
              :input-error="$v.usuario.telefono.$error"
              :label="$t('mEditionAccountProfile.inputs.telefono.label')"
              :message-error="messageErrorTelefono"
              name="telefono"
              reference="telefono"
              type="text"
              @blur="$v.usuario.telefono.$touch()"
            />
          </div>

          <div class="column column-5">
            <AtomInputPrimary
              v-model="usuario.movil"
              :input-error="$v.usuario.movil.$error"
              :label="$t('mEditionAccountProfile.inputs.movil.label')"
              :message-error="messageErrorMovil"
              name="movil"
              reference="movil"
              type="text"
              @blur="$v.usuario.movil.$touch()"
            />
          </div>
        </div>

        <div class="row">
          <div class="column column-10">
            <AtomButtonPrimary :button-primary="buttonPrimary"/>
            <AtomButtonSecondary
              v-if="false"
              :button-secondary="buttonSecondary.reset"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAccountProfile',

  data () {
    return {
      buttonPrimary: {
        action: 'Guardar',
        class: 'margin-right-medium margin-top-large',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-reset-secondary',
          component: '',
          icon: '',
          method: '',
          text: this.$t('aButtonSecondary.actions.reset'),
          type: 'reset'
        }
      },

      date: {
        day: '',
        month: '',
        year: ''
      },

      documentoTipos: [],
      paises: [],

      provincias: [],
      showLoadingState: 0,

      usuario: {
        avatar: '',
        cod_postal: '',
        documento_numero: '',
        documento_tipo: '',
        email: '',
        fecha_alta: '',
        fisica: 1,
        linea1: '',
        linea2: '',
        localidad: '',
        movil: '',
        pais: '',
        provincia: '',
        razon_social: '',
        telefono: ''
      }
    }
  },

  validations: {
    usuario: {
      documento_numero: {
        maxLength: maxLength(30),
        minLength: minLength(3),
        required
      },

      documento_tipo: {
        required
      },

      fisica: {
        required
      },

      movil: {
        required
      },

      pais: {
        required
      },

      provincia: {
        required
      },

      razon_social: {
        maxLength: maxLength(150),
        minLength: minLength(3),
        required
      },

      telefono: {
        required
      }
    }
  },

  computed: {
    messageErrorDocumentoNum () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.documento_numero, 'documento_numero')
    },

    messageErrorFisica () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.fisica, 'fisica')
    },

    messageErrorMovil () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.movil, 'movil')
    },

    messageErrorPais () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.pais, 'pais')
    },

    messageErrorProvincia () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.provincia, 'provincia')
    },

    messageErrorRazonSocial () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.razon_social, 'razon_social')
    },

    messageErrorTelefono () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.telefono, 'telefono')
    },

    messageErrorTipoDoc () {
      return this.$validation.getValidationMessage('mEditionAccountProfile', this.$v.usuario.documento_tipo, 'documento_tipo')
    }
  },

  watch: {
    'usuario.pais' (newValue, oldValue) {
      if (oldValue !== '' && newValue !== oldValue) {
        this.usuario.provincia = ''
      }
    }
  },

  created () {
    this.readUser()
    this.readParametroPaises()
  },

  methods: {
    changeAvatarImage (avatarImg) {
      this.usuario.avatar = avatarImg
    },

    readParametroDocumentoTipos (idPais) {
      this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [idPais])
        .then(response => {
          this.documentoTipos = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroProvincias (idPais) {
      this.$services.read('parametro', 'readParametroProvincias', {}, [idPais])
        .then(response => {
          this.provincias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.provincias = []
          this.showLoadingState++
        })
    },

    readUser () {
      this.$services.read('usuario', 'readUsuario')
        .then(response => {
          if (response.data.persona) {
            this.usuario.email = response.data.email
            this.usuario.fecha_alta = response.data.fecha_alta
            this.usuario.fisica = response.data.persona.fisica ? +response.data.persona.fisica : 0
            this.usuario.avatar = response.data.avatar ? response.data.avatar : this.$store.getters.getUserData.picture
            this.usuario.movil = response.data.persona.movil ? response.data.persona.movil : response.data.persona.movil
            this.usuario.razon_social = response.data.persona.razon_social ? response.data.persona.razon_social : ''
            this.usuario.telefono = response.data.persona.telefono ? response.data.persona.telefono : ''

            if (response.data.persona.domicilio) {
              this.usuario.cod_postal = response.data.persona.domicilio.codigo_postal ? response.data.persona.domicilio.codigo_postal : ''
              this.usuario.linea1 = response.data.persona.domicilio.linea1 ? response.data.persona.domicilio.linea1 : ''
              this.usuario.linea2 = response.data.persona.domicilio.linea2 ? response.data.persona.domicilio.linea2 : ''
              this.usuario.localidad = response.data.persona.domicilio.localidad ? response.data.persona.domicilio.localidad : ''
              this.usuario.pais = response.data.persona.domicilio.provincia.pais.id_pais ? response.data.persona.domicilio.provincia.pais.id_pais : ''
              this.usuario.provincia = response.data.persona.domicilio.provincia.id_provincia ? response.data.persona.domicilio.provincia.id_provincia : ''
            }

            if (response.data.persona.documento) {
              this.usuario.documento_numero = response.data.persona.documento.numero ? response.data.persona.documento.numero : ''
              this.usuario.documento_tipo = response.data.persona.documento.tipo.id_documento_tipo ? response.data.persona.documento.tipo.id_documento_tipo : ''
            }
          } else {
            this.usuario.avatar = response.data.avatar ? response.data.avatar : this.$store.getters.getUserData.picture
            this.usuario.email = response.data.email
            this.usuario.fecha_alta = response.data.fecha_alta
          }

          if (this.usuario.pais) {
            this.readParametroDocumentoTipos(this.usuario.pais)
            this.readParametroProvincias(this.usuario.pais)
          } else {
            this.showLoadingState++
            this.showLoadingState++
          }

          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    updateUser () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('usuario', 'updateUsuario', this.usuario)
          .then(response => {
            let storedUser = Object.assign({}, this.$store.getters.getUserData)
            storedUser.vidroop_data = Object.assign({}, response.data)
            localStorage.setItem('user', JSON.stringify(storedUser))
            this.$store.commit('setUserData', storedUser)
            this.usuario.avatar = response.data.avatar ? response.data.avatar : this.$store.getters.getUserData.picture
            this.$alerts.pushAlert('mEditionAccountProfile', 'updateUsuario', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAccountProfile', 'updateUsuario', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
